import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { usePlatformAuth } from '../auth/PlatformAuthContext';

const NAV = [
  { to: '/platform/dashboard', label: 'Hospitals' },
  { to: '/platform/onboard', label: '+ Onboard' },
  { to: '/platform/analytics', label: 'Analytics' },
  { to: '/platform/audit', label: 'Fleet audit' },
  { to: '/platform/admins', label: 'HCEN admins' },
];

export default function PlatformShell({ title, subtitle, children, actions }) {
  const { user, logout } = usePlatformAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="page platform-page">
      <header className="topbar">
        <div>
          <h1 className="topbar-title">{title}</h1>
          <p className="topbar-sub">{subtitle || `${user?.name || user?.email} — HCEN platform owner`}</p>
        </div>
        <div className="topbar-actions">
          {actions}
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`btn btn-sm ${location.pathname === item.to || location.pathname.startsWith(item.to + '/') ? 'btn-primary' : 'btn-secondary'}`}
            >
              {item.label}
            </Link>
          ))}
          <a href="/login" className="btn btn-secondary btn-sm">Staff login</a>
          <button type="button" className="btn btn-secondary btn-sm" onClick={() => { logout(); navigate('/platform/login'); }}>
            Logout
          </button>
        </div>
      </header>
      <div className="page-body">{children}</div>
    </div>
  );
}
